/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_When_AlwaysInputs */

const en_us2_bodymap_when_always = /** @type {(inputs: Bodymap_When_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All the time`)
};

const pt_br2_bodymap_when_always = /** @type {(inputs: Bodymap_When_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tempo todo`)
};

const es_419_bodymap_when_always = /** @type {(inputs: Bodymap_When_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo el tiempo`)
};

const pt_pt2_bodymap_when_always = /** @type {(inputs: Bodymap_When_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tempo todo`)
};

const fr_fr2_bodymap_when_always = /** @type {(inputs: Bodymap_When_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout le temps`)
};

const de_de2_bodymap_when_always = /** @type {(inputs: Bodymap_When_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die ganze Zeit`)
};

const it_it2_bodymap_when_always = /** @type {(inputs: Bodymap_When_AlwaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sempre`)
};

/**
* | output |
* | --- |
* | "All the time" |
*
* @param {Bodymap_When_AlwaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_when_always = /** @type {((inputs?: Bodymap_When_AlwaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_When_AlwaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_when_always(inputs)
	if (locale === "es-419") return es_419_bodymap_when_always(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_when_always(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_when_always(inputs)
	if (locale === "de-DE") return de_de2_bodymap_when_always(inputs)
	if (locale === "it-IT") return it_it2_bodymap_when_always(inputs)
	return en_us2_bodymap_when_always(inputs)
});
export { bodymap_when_always as "bodymap.when.always" }